import { render, staticRenderFns } from "./enterpriseincome.vue?vue&type=template&id=2e12af22&scoped=true&"
import script from "./enterpriseincome.vue?vue&type=script&lang=js&"
export * from "./enterpriseincome.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseincome.vue?vue&type=style&index=0&id=2e12af22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e12af22",
  null
  
)

export default component.exports